import { create } from 'zustand';

interface HelpDrawerStore {
  open: boolean;
  setOpen: (v: boolean) => void;
  toggle: () => void;
}

export const useHelpDrawerStore = create<HelpDrawerStore>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
  toggle: () => set((s) => ({ open: !s.open })),
}));
